import { createContext } from 'react';

export const RemainingTimeContext = createContext('');
